import config from 'config';

export default function () {
  window.fbAsyncInit = () => {
    FB.init({
      appId: config.SocialAuth.facebookID,
      status: true,
      cookie: true,
      xfbml: true,
      version: 'v2.4'
    });
  };
  (function(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);
    js.id = id;
    js.src = "//connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));
}



// WEBPACK FOOTER //
// ./source/client/layout-components/account/facebook-auth/facebook-auth.js